import { GenericBackendResponse } from '../genericBackendResponse';
import { AdhesionMode } from './getAdhesionDetails';
import { UserEppConfigForModeI } from './interfaces/UserEppConfigForMode';

/**
 * `GET /users/epp-config?mode=` (Fase 4 backend, épica multi-cuenta). Devuelve
 * la fila de `user_epp_config` del plan pedido (`data: null` si el usuario no
 * tiene plan de ese modo). Con 1 sola fila, el backend la devuelve siempre
 * independientemente del modo pedido (comportamiento actual, sin cambios).
 */
const getUserEppConfigForMode = async (
	token: string,
	mode: AdhesionMode,
	userEppConfigId?: string
): Promise<GenericBackendResponse<UserEppConfigForModeI | null>> => {
	// Con dos planes del MISMO tipo, `mode` no nombra una fila: el backend
	// resuelve por orden y la vista acabaría enseñando un plan que el usuario no
	// eligió. El selector de vista manda el `id` de la entrada elegida.
	const planQuery = userEppConfigId
		? `&userEppConfigId=${encodeURIComponent(userEppConfigId)}`
		: '';

	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/users/epp-config?mode=${mode}${planQuery}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	return response.json();
};

export default getUserEppConfigForMode;
